// extracted by mini-css-extract-plugin
export default {"container":"AboutScreen_container__Ul3e1"};